/*!
 *
 * Copyright 2019 Dmitry Chuba
 */

jQuery(function ($) {
    'use strict';

    // Scroll class
    {
        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 300) {
                $('body').addClass('scroll');
            } else {
                $('body').removeClass('scroll');
            }
        }).trigger('scroll');

        $('.back-to-top').on('click', function () {
            $("html, body").animate({
                scrollTop : 0
            }, 500);
        });
    }



});
